import React, { useState } from 'react'
import PropTypes from 'prop-types'

import AppBarMobile from '../../ui/components/AppBarMobile'
import SearchShipmentsModal from '../SearchShipmentsModal'

const MobileNavigation = ({ onLogout, isLoggingOut }) => {
  const [isSearchOpen, setIsSearchOpen] = useState(false)

  return (
    <>
      <AppBarMobile
        onLogout={onLogout}
        isLoggingOut={isLoggingOut}
        onClickSearch={() => setIsSearchOpen(true)}
      />
      <SearchShipmentsModal
        isOpen={isSearchOpen}
        onClose={() => setIsSearchOpen(false)}
      />
    </>
  )
}

MobileNavigation.propTypes = {
  onLogout: AppBarMobile.propTypes.onLogout,
  isLoggingOut: PropTypes.bool,
}

export default MobileNavigation
